import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const SetAscendingOnly = new ReduxAsyncAction<'SET_ASCENDING_ONLY', boolean | undefined, boolean | undefined>(
  'SET_ASCENDING_ONLY'
);

SetAscendingOnly.registerRequest(async (ascendingOnly?: boolean) => {
  return ascendingOnly;
});

export const SET_ASCENDING_ONLY = SetAscendingOnly.actionNamespaceConstants;

export const setAscendingOnly = SetAscendingOnly.request;

export type SetAscendingOnlyResponseAction = Action<typeof SET_ASCENDING_ONLY.response> & { data: boolean };
